import React from "react";
import "./Tabular.css";

const Tabular = ({ headers = [], rows = [] }) => {
  return (
    <div className="tabular">
      {/* Optional Headers */}
      {headers.length > 0 && (
        <div className="tabular-header">
          {headers.map((header, index) => (
            <div key={index} className="tabular-header-cell">
              {header}
            </div>
          ))}
        </div>
      )}

      {/* Rows */}
      <div className="tabular-body">
        {rows.map((row, rowIndex) => (
          <div key={rowIndex} className="tabular-row">
            {row.map((cell, cellIndex) => (
              <div key={cellIndex} className="tabular-cell">
                {typeof cell === "object" && cell.type === "button" ? (
                  <button onClick={() => window.location.href = cell.link} className="tabular-button">
                    {cell.text}
                  </button>
                ) : typeof cell === "object" && cell.type === "link" ? (
                  <a href={cell.link} className="tabular-link">{cell.text}</a>
                ) : (
                  cell
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tabular;
